/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Sidebar from "./components/sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import Header from "./components/header/Header";
import { useSelector } from "react-redux";
import { ThemeColorProvider, } from "../utils/Context/ThemeColorContext";
import PageLoader from "../components/ui/pageLoader/PageLoader";

const Layout = (props) => {
  // Get the current location using React Router's useLocation hook
  const [headerCollapsed, setHeaderCollapsed] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(window.innerWidth <= 1024);
  const [isSidebarModelOpen, setIsSidebarModelOpen] = useState(false);
  const lastWidth = useRef(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      const wasMobile = lastWidth.current <= 1024;
      const isMobile = currentWidth <= 1024;

      if (wasMobile !== isMobile) {
        setSidebarCollapsed(isMobile);
      }
      lastWidth.current = currentWidth;
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleHeaderCollapsed = () => {
    setHeaderCollapsed((prevState) => !prevState);
  };

  const handleModelOpen = () => {
    setIsSidebarModelOpen(!isSidebarModelOpen);
  };

  const toggleSidebarCollapsed = () => {
    setSidebarCollapsed((prevState) => !prevState);
  };

  const { user } = useSelector((state) => state.auth);

  return (
    <ThemeColorProvider>
      <div className={`main-page-layout ${headerCollapsed ? "toggled" : ""}`}>
        <div className={`middle-page-section`}>
          <div className={`center-content-part ${sidebarCollapsed ? "collapsed" : ""}`}>
            <Sidebar
              componentRoutes={props.componentRoutes}
              headerCollapsed={headerCollapsed}
              sidebarCollapsed={sidebarCollapsed}
              toggleSidebarCollapsed={toggleSidebarCollapsed}
            />
            {!sidebarCollapsed && (
              <div 
                className="layout-sidebar-backdrop" 
                onClick={toggleSidebarCollapsed}
              />
            )}
            <div className={`right-sec-part ${isSidebarModelOpen ? "sidebar-backdrop" : ""}`}>
              {/* <div className={`right-sec-part`}> */}
              <Header
                onModelOpen={handleModelOpen}
                user={user}
                toggleHeaderCollapsed={toggleHeaderCollapsed}
                toggleSidebarCollapsed={toggleSidebarCollapsed}
              />
              <div className="sidebar-detail-content">
                <React.Suspense fallback={<PageLoader />}>
                  <Outlet />
                </React.Suspense>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThemeColorProvider>
  );
};

export default Layout;
